var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBipLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.005,
    height: 38,
    viewBox: "0 0 38.005 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    transform: "translate(-251.628 -590.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M29.884,29.88c-2.079,2.077-6.144,3.314-10.878,3.314S10.2,31.957,8.129,29.88,4.8,23.737,4.8,19s1.245-8.8,3.323-10.876,6.149-3.322,10.885-3.322,8.8,1.243,10.878,3.322S33.205,14.271,33.205,19,31.956,27.8,29.884,29.88ZM38.005,19a19,19,0,1,0-1.446,7.271A19,19,0,0,0,38.005,19Z",
    transform: "translate(251.628 590.019)",
    fill: "#fc6423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M22.668,16.341v5.193A1.077,1.077,0,0,1,21.6,22.616H16.39a1.069,1.069,0,0,1-1.077-1.062c0-.007,0-.013,0-.02V16.341a1.078,1.078,0,0,1,1.074-1.083h5.206a1.078,1.078,0,0,1,1.075,1.082Z",
    transform: "translate(251.628 590.019)",
    fill: "#fc6423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M27.9,10.035C26.427,8.563,22.93,7.609,18.99,7.609s-7.437.953-8.909,2.426-2.424,4.973-2.424,8.914.946,7.442,2.424,8.916,4.97,2.424,8.909,2.424,7.437-.953,8.909-2.424,2.426-4.975,2.426-8.916S29.379,11.5,27.9,10.035Zm-3.44,14.346c-.306.306-1.245,1.243-5.5,1.243s-5.194-.933-5.5-1.243-1.243-1.243-1.243-5.5.933-5.193,1.243-5.5,1.237-1.237,5.5-1.237,5.185.927,5.5,1.237,1.236,1.243,1.236,5.5-.932,5.184-1.236,5.493Z",
    transform: "translate(251.628 590.019)",
    fill: "#fc6423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436-2",
    "data-name": "Path 2436",
    d: "M29.884,29.88c-2.079,2.077-6.144,3.314-10.878,3.314S10.2,31.957,8.129,29.88,4.8,23.737,4.8,19s1.245-8.8,3.323-10.876,6.149-3.322,10.885-3.322,8.8,1.243,10.878,3.322S33.205,14.271,33.205,19,31.956,27.8,29.884,29.88ZM38.005,19a19,19,0,1,0-1.446,7.271A19,19,0,0,0,38.005,19Z",
    transform: "translate(251.628 590.019)",
    fill: "#fc6423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437-2",
    "data-name": "Path 2437",
    d: "M22.668,16.341v5.193A1.077,1.077,0,0,1,21.6,22.616H16.39a1.069,1.069,0,0,1-1.077-1.062c0-.007,0-.013,0-.02V16.341a1.078,1.078,0,0,1,1.074-1.083h5.206a1.078,1.078,0,0,1,1.075,1.082Z",
    transform: "translate(251.628 590.019)",
    fill: "#fc6423"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438-2",
    "data-name": "Path 2438",
    d: "M27.9,10.035C26.427,8.563,22.93,7.609,18.99,7.609s-7.437.953-8.909,2.426-2.424,4.973-2.424,8.914.946,7.442,2.424,8.916,4.97,2.424,8.909,2.424,7.437-.953,8.909-2.424,2.426-4.975,2.426-8.916S29.379,11.5,27.9,10.035Zm-3.44,14.346c-.306.306-1.245,1.243-5.5,1.243s-5.194-.933-5.5-1.243-1.243-1.243-1.243-5.5.933-5.193,1.243-5.5,1.237-1.237,5.5-1.237,5.185.927,5.5,1.237,1.236,1.243,1.236,5.5-.932,5.184-1.236,5.493Z",
    transform: "translate(251.628 590.019)",
    fill: "#fc6423"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBipLogo);
export default __webpack_public_path__ + "static/media/InfoBipLogo.201a740faf3e0fba873394b2a546c7c7.svg";
export { ForwardRef as ReactComponent };